import React, {useState} from 'react'
import AddButton from '../../../shared/actionButtons/AddButton'
import DeleteButton from '../../../shared/actionButtons/DeleteButton'
import EditButton from '../../../shared/actionButtons/EditButton'
import DeleteModals from './DeleteModals'
import EducationModal from './EditModals/EducationModal'

type Props = {}

function Education({}: Props) {
  const [educationModal, seteducationModal] = useState(false)
  const [deleteModal, setdeleteModal] = useState(false)
  const [activeEducation, setactiveEducation] = useState<string>('')
  const handleeducationModal = () => {
    seteducationModal(!educationModal)
  }
  const handleDeleteModal = () => {
    setdeleteModal(!deleteModal)
  }
  return (
    <div className='card-body pt-9 pb-0 '>
      <div className='d-flex'>
        <EducationModal handleEditModal={handleeducationModal} editModal={educationModal} />
        <DeleteModals
          handleDeleteModal={handleDeleteModal}
          title={activeEducation}
          deleteModal={deleteModal}
        />

        <div className='fs-3 fw-bold mb-9'> Education</div>
        <div>
          <AddButton handleAddModal={handleeducationModal} title={'Add'} />
        </div>
      </div>
      <div className='mb-9'>
        <div className='mb-8'>
          <div className='d-flex justify-content-between'>
            <div className='d-flex flex-column flex-wrap'>
              <div className=''>
                {' '}
                <span className='fs-sm '> January 2015 - September 2018</span>
              </div>
              <div className='fs-3   mb-2 text-uppercase'> wolkite university</div>
              <div className=''>
                {' '}
                <span className='fs-sm  '> Software Engineering</span>
              </div>
            </div>

            <div className=' d-flex justify-content-start align-items-center   '>
              <EditButton handleEditModal={handleeducationModal} />
              <DeleteButton
                handleDeleteModal={handleDeleteModal}
                setActive={setactiveEducation}
                activeItem={'Wolkite university from your education list?'}
                className='mx-2'
              />
            </div>
          </div>
        </div>
        <div className='mb-4'>
          <div className='d-flex justify-content-between'>
            <div className='d-flex flex-column flex-wrap'>
              <div className=''>
                {' '}
                <span className='fs-sm '> January 2015 - September 2018</span>
              </div>
              <div className='fs-3   mb-2 text-uppercase'> wolkite university</div>
              <div className=''>
                {' '}
                <span className='fs-sm  '> Software Engineering</span>
              </div>
            </div>

            <div className=' d-flex justify-content-start align-items-center   '>
              <EditButton handleEditModal={handleeducationModal} />
              <DeleteButton
                handleDeleteModal={handleDeleteModal}
                setActive={setactiveEducation}
                activeItem={'Wolkite university from your education list?'}
                className='mx-2'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Education
